import { render, staticRenderFns } from "./VersicherungsartTree.vue?vue&type=template&id=16daa09a"
import script from "./VersicherungsartTree.vue?vue&type=script&lang=js"
export * from "./VersicherungsartTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports